import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { OfflineIndicator } from '@leanpay/ui'

import AppStore from './app/app-store'
import MainLayout from './app/main-layout'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AppStore>
                    <OfflineIndicator />
                    <MainLayout />
                </AppStore>
            </BrowserRouter>
        </QueryClientProvider>
    )
}

export default App
